export default __webpack_public_path__ + "static/media/640_dummy2016-schneiderei01-de.7d8b8c02.png";